import React, { Component } from "react";
import { Sock } from "./garments";

export class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer kd-footer">
          <div className="kd-footer-row">
            <p className="kd-footer-brand">
              <span className="kd-footer-ring" aria-hidden="true" />
              © {new Date().getFullYear()} KIDO, where dreams begin
            </p>
            <p className="kd-footer-socks">
              Made for growing up.
              <svg viewBox="-30 -8 90 70" aria-hidden="true" focusable="false">
                <Sock />
                <g transform="translate(34 4) rotate(8)">
                  <Sock color="#A99BFF" />
                </g>
              </svg>
            </p>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;
